<div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit" style="height: 100%; padding: 0;"
  (click)="common.outSide($event)">
  <div class="header col-sm-12" [ngClass]="{'headerAuto': isDevis}">
    <div class="" [ngClass]="{'col-sm-5': !pasFicheClient, 'col-sm-12': !pasFicheClient}">
      <h3 *ngIf="!pasFicheClient"> {{ isHisto ? 'Historique' : 'Liste' }} des FIP {{ isDD ? 'DD' : 'DND' }} </h3>
      <div *ngIf="!pasFicheClient" class="text-underline historique" style="padding-right: 0px" (click)="showHisto()">
        <span *ngIf="!isHisto"> Afficher l'historique </span>
        <span *ngIf="isHisto"> Afficher la liste </span>
      </div>

      <h4 *ngIf="pasFicheClient && !isDevis" style="margin-bottom: 0;"> Renseignement des FIPs {{ isDD ? 'DD' : 'DND' }}
        du client
        {{bon.client &&
        bon.client.codeClient ? bon.client.codeClient + '/' : '' }} {{bon.client &&
        bon.client.nomClient ? bon.client.nomClient : '' }} Bon : {{ bon.numBon }} </h4>

      <h4 *ngIf="pasFicheClient && isDevis" style="margin-bottom: 0;"> Renseignement des FIPs {{ isDD ? 'DD' : 'DND' }}
      </h4>

    </div>
    <div class="col-sm-7 text-right" style="white-space: nowrap; padding: 0px" *ngIf="!pasFicheClient">
      <button class="btn-header uppercase" id="close3" (click)="extraireXls()"> Extraire en XLS </button>
      <button class="btn-header uppercase" id="close2" (click)="hide()" style="margin: 0 3px"> Fermer </button>
      <button class="btn-header uppercase actionPricipal" id="close1" (click)="saveModif()"> Valider </button>
    </div>
  </div>

  <div class="col-sm-12 ligneBon liste"
    [ngStyle]="{ 'height' : pasFicheClient ? 'calc(100% - 130px)' : (isDepuisMenuEnHaut ? 'calc(100% - 168px)' : 'calc(100% - 178px)')}">
    <ngx-datatable *ngIf="renderTable" style="height: 100%" class="material" [rows]="listFIP || []"
      [columnMode]="'force'" [headerHeight]="30" [footerHeight]="0" [rowHeight]="auto" [selectionType]="'single'"
      [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
      [loadingIndicator]="loadingIndicator" [selected]="selected" [scrollbarH]="pasFicheClient ? true : false">

      <ngx-datatable-column prop="numFIP">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Num FIP </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="annee" *ngIf="!societe.isFIPCET">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Année </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="codeBanque" prop="nomenclatureICPE.rubrique" *ngIf="!societe.isFIPCET && !isDD">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Rubrique </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{ value || (row.nomenclatureICPE ? row.nomenclatureICPE.libelleObjetEntite : '')}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="codeBanque" prop="artLibelle">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Article </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{ value || (row.article ? row.article.libelleObjetEntite : '') }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="chantierLibelle" *ngIf="societe.isFIPCET || isDD">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Chantier </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
          <div>
            {{row.chantierRespVille}}
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="qteEstime" *ngIf="!societe.isFIPCET">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Qté estimée </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <span *ngIf="!pasFicheClient">{{ value }}</span>
          <input *ngIf="pasFicheClient" type="number" class="form-control" [(ngModel)]="row.qteEstime"
            autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')">
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="signee">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Signée </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <span *ngIf="!pasFicheClient">{{value ? 'Oui' : 'Non'}}</span>
          <mat-checkbox *ngIf="pasFicheClient" [color]="'primary'" [(ngModel)]="row.signee"
            (ngModelChange)="changeSignee(row)">
          </mat-checkbox>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="refusee">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Refusée </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <span *ngIf="!pasFicheClient">{{value ? 'Oui' : 'Non'}}</span>
          <mat-checkbox *ngIf="pasFicheClient" [disabled]="row.signee" [color]="'primary'" [(ngModel)]="row.refusee">
          </mat-checkbox>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="motifRefusFIP.libelle">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Motif Refus </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <span *ngIf="!pasFicheClient">{{value || (row.motifRefusFIP && row.motifRefusFIP.id ?
            row.motifRefusFIP.libelleObjetEntite : 'A définir') }}</span>
          <div class="champ" *ngIf="pasFicheClient" style="padding-right: 0px"
            [ngClass]="{'disabledbutton': !row.refusee}">
            <app-autocomplete [placeholder]="'Motif Refus'" (searchfunction)="searchMotif($event)"
              (selectfunction)="row.motifRefusFIP = $event;" [results]="dataMotif" [label]="''"
              id="modedepaie autoMotif" [disablefocus]="true" [container]="true"
              [defaultsearch]="row.motifRefusFIP && row.motifRefusFIP.id ? row.motifRefusFIP.libelle || row.motifRefusFIP.libelleObjetEntite : ''"
              [dropdownclass]="'dropDownPrixNego maxZindex'"></app-autocomplete>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="isLimite" *ngIf="societe.isFIPCET">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Limite </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <span *ngIf="!pasFicheClient">{{value ? 'Oui' : 'Non'}}</span>
          <mat-checkbox *ngIf="pasFicheClient" [color]="'primary'" [(ngModel)]="row.isLimite"></mat-checkbox>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="limite" *ngIf="societe.isFIPCET">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Qté limite </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <span *ngIf="!pasFicheClient">{{ value }}</span>
          <input *ngIf="pasFicheClient" type="text" class="form-control" [(ngModel)]="row.limite" autocomplete="off"
            (keydown.enter)="common.focusNext('.modalFicheClient')">
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="dateFilter">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Date enreg. </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{ row.dateCreation}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column prop="site.nom" *ngIf="societe.isFIPParSite">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Site </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>


      <ngx-datatable-column [width]="40" [sortable]="false" *ngIf="!pasFicheClient" [canAutoResize]="false"
        [draggable]="false" [resizeable]="false">
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
          <div class="text-center">
            <button class="btn-detail" (click)="editRow(row);">
              <i class="fa fa-pencil"></i>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div class="addLigne col-sm-12 uppercase" *ngIf="!pasFicheClient && !isHisto">
    <div class="col-sm-7 text-left">
      <button class="btn-add" id="addLigne" (click)="selectedRow = {};isEdit = true; addLigne()">
        <i class="fa fa-plus"></i>
      </button>
      <span (click)="selectedRow = {}; isEdit = true; addLigne()">Ajouter une ligne</span>

    </div>
    <label class="text-left uppercase text-underline historique col-sm-5"></label>
  </div>
  <div class="text-right col-sm-12" *ngIf="pasFicheClient" style="margin-top: 15px;">
    <button type="button" class=" btn-header uppercase actionPricipal" (click)="saveModif();"
      style="margin-right: 5px;">
      Valider
    </button>
    <button type="button" class=" btn-header uppercase" (click)="hide();"> Fermer</button>
  </div>
</div>


<app-empty-detail-fact class="col-sm-12 detail" *ngIf="isEmpty && !pasFicheClient" id="empty"></app-empty-detail-fact>

<div class="col-sm-12 detail" style="height: 100%; padding: 0px" *ngIf="isEdit" #formEdit
  (click)="common.outSide($event)">
  <div class="modal-header col-sm-12" style="padding: 5px;" (click)="common.outSide($event)">
    <h4 class="modal-title pull-left col-sm-8"> {{selectedRow.id ? ('Modifier un FIP' + (isDD ? ' DD' : ' DND')) :
      ('Ajouter un FIP'
      + (isDD ? ' DD' : ' DND'))}} </h4>
    <div class="col-sm-4 text-right">
      <button type="button" class="btn-header uppercase" (click)="selectedRow = {};isEdit = false;"
        style="margin-right: 3px;"> Fermer
      </button>
      <button type="button" class="btn-header uppercase actionPricipal" (click)="valideFIPBeforeSave();">
        Valider </button>
    </div>
  </div>
  <div class="modalFicheClient col-sm-12" style=" padding-top: 10px;">
    <div class="col-sm-12">
      <div class="form-group items col-sm-12" *ngIf="!societe.isFIPCET && !isDD">
        <label class="col-sm-3 champ" style="padding:0px">
          Rubrique :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px"
          [ngClass]="{'disabledbutton': selectedRow.checkOperation}">
          <app-autocomplete [placeholder]="'Rubrique'" (searchfunction)="searchRubrique($event)"
            (selectfunction)="selectedRow.nomenclatureICPE = $event;" [notOblig]="true" [label]="''"
            [selectvalue]="true" [results]="dataRubrique" [id]="'modedepaie nomenclatureICPE'"
            [defaultsearch]="selectedRow.nomenclatureICPE ? (selectedRow.nomenclatureICPE.rubrique || selectedRow.nomenclatureICPE.libelleObjetEntite) : ''"
            [autohide]="true" [dropdownclass]="'dropDownPrixNego'" (keyenterfunction)="common.focusNext('.ligneBon')">
          </app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12" *ngIf="societe.isFIPCET || isDD">
        <label class="col-sm-3 champ" style="padding:0px">
          Article :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px"
          [ngClass]="{'disabledbutton': selectedRow.checkOperation}">
          <app-autocomplete [placeholder]="'Article'" (searchfunction)="searchArticle($event)"
            (selectfunction)="selectedRow.article = $event;" [notOblig]="true" [label]="''" [selectvalue]="true"
            [results]="dataArticle" [id]="'modedepaie article'"
            [defaultsearch]="selectedRow.article ? (selectedRow.article.libelle || selectedRow.article.libelleObjetEntite) : ''"
            [autohide]="true" [dropdownclass]="'dropDownPrixNego'" (keyenterfunction)="common.focusNext('.ligneBon')">
          </app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12" *ngIf="societe.isFIPCET || isDD">
        <label class="col-sm-3 champ" style="padding:0px">
          Chantier :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px"
          [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
          <app-autocomplete [placeholder]="'Chantier'" (searchfunction)="searchChantier($event)"
            (selectfunction)="selectedRow.chantier = $event;" [results]="listChantier" [showonclick]="true" [label]="''"
            id="modedepaie autoCht" [defaultsearch]="selectedRow.chantier ? selectedRow.chantier.numChantier : ''"
            [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12" *ngIf="!societe.isFIPCET">
        <label class="col-sm-3 champ" style="padding:0px">
          Qté estimée :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="number" class="form-control" [(ngModel)]="selectedRow.qteEstime" autocomplete="off"
            (keydown.enter)="common.focusNext('.modalFicheClient')">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Signée :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <div>
            <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.signee" (ngModelChange)="changeSignee()">
            </mat-checkbox>
          </div>
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Refusée :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': selectedRow.signee}">
          <div>
            <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.refusee"></mat-checkbox>
          </div>
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Motif Refus :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': !selectedRow.refusee}">
          <app-autocomplete [placeholder]="'Motif Refus'" (searchfunction)="searchMotif($event)"
            (selectfunction)="selectedRow.motifRefusFIP = $event;" [results]="dataMotif" [label]="''"
            id="modedepaie autoMotif" [disablefocus]="true"
            [defaultsearch]="selectedRow.motifRefusFIP && selectedRow.motifRefusFIP.id ? selectedRow.motifRefusFIP.libelle || selectedRow.motifRefusFIP.libelleObjetEntite : ''"
            [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12" *ngIf="societe.isFIPCET">
        <label class="col-sm-3 champ" style="padding:0px">
          Limite :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <div>
            <mat-checkbox [color]="'primary'" [(ngModel)]="selectedRow.isLimite"></mat-checkbox>
          </div>
        </div>
      </div>
      <div class="form-group items col-sm-12" *ngIf="societe.isFIPCET">
        <label class="col-sm-3 champ" style="padding:0px">
          Qte limite :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': !selectedRow.isLimite}">
          <input type="text" class="form-control" [(ngModel)]="selectedRow.limite" autocomplete="off"
            (keydown.enter)="common.focusNext('.modalFicheClient')">
        </div>
      </div>
      <div class="form-group items col-sm-12" *ngIf="!societe.isFIPCET">
        <label class="col-sm-3 champ" style="padding:0px">
          Année :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="selectedRow.annee" autocomplete="off"
            (keydown.enter)="common.focusNext('.modalFicheClient')">
        </div>
      </div>

      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Date d'enregistrement :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <app-input-date [class]="'form-control'" [id]="'date'" [model]="selectedRow.modelDebut"
            (changefct)="selectedRow.modelDebut = $event; changeDateDebut($event, selectedRow);"
            [placeholder]="'Date d\'enregistrement'"
            (keyenterfct)="common.changeDate($event, selectedRow.modelDebut, '#dateF');" [dateVide]="true"
            (selectfct)="selectDate($event, '#dateF');" [showDatepicker]="true" [closeDatepickerOnSelect]="true">
          </app-input-date>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
      </button>
    </div>
  </div>
</ng-template>



<div class="spinner" id="spinnerCont" *ngIf="isClick">
  <div class="sk-fading-circle">
    <div class="sk-circle1 sk-circle"></div>
    <div class="sk-circle2 sk-circle"></div>
    <div class="sk-circle3 sk-circle"></div>
    <div class="sk-circle4 sk-circle"></div>
    <div class="sk-circle5 sk-circle"></div>
    <div class="sk-circle6 sk-circle"></div>
    <div class="sk-circle7 sk-circle"></div>
    <div class="sk-circle8 sk-circle"></div>
    <div class="sk-circle9 sk-circle"></div>
    <div class="sk-circle10 sk-circle"></div>
    <div class="sk-circle11 sk-circle"></div>
    <div class="sk-circle12 sk-circle"></div>
  </div>
</div>